import { render, staticRenderFns } from "./replacedQr.vue?vue&type=template&id=60afc489&scoped=true"
import script from "./replacedQr.vue?vue&type=script&lang=js"
export * from "./replacedQr.vue?vue&type=script&lang=js"
import style0 from "./replacedQr.vue?vue&type=style&index=0&id=60afc489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afc489",
  null
  
)

export default component.exports